import { render, staticRenderFns } from "./PageTemplateEditAccessError.vue?vue&type=template&id=687cf65c"
import script from "./PageTemplateEditAccessError.js?vue&type=script&lang=js&external"
export * from "./PageTemplateEditAccessError.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports